import React from "react";
import { Toast } from "primereact/toast";
import { Divider } from "primereact/divider";
import { SplitButton } from "primereact/splitbutton";
import { confirmDialog } from "primereact/confirmdialog";
import { OrderList } from "primereact/orderlist";
import SchoolHat from "../assets/school_hat.png";
import constants from "../constants";
import { deleteSchool } from "../apis/School";
import { useAuthStore } from "../store/AuthStore";
import { useSchoolStore } from "../store/SchoolStore";
import AddEditSchool from "../components/common/AddEditSchool";
import { useRouterActions } from "react-resource-router";
import utils from "../utils";
import { getSchoolsByOwner, getSchoolsByUser } from "../apis/School";
import { useResourcesStore } from "../store/ResourcesStore";
import { getRole } from "../apis/Utilities";

const Welcome = ({ toast }) => {

  const { push } = useRouterActions();
  const [state] = useAuthStore();
  const [{ userSchools, ownerSchools }, { onSelectSchool, resetSchool }] = useSchoolStore();
  const [, { onOwnerSchools, onUserSchools }] = useResourcesStore();
  const toastW = React.useRef(toast);
  const [school, setSchool] = React.useState(null);
  const [isCreateSchool, setIsCreateSchool] = React.useState(false);
  const [hasSchool, setHasSchool] = React.useState(false);
  const [schools, setSchools] = React.useState([]);
  const [schId, setSchId] = React.useState(null);

  function handleOnEidt() {
    setSchId(null);
  }

  async function fetchUserSchoolData() {
    const usd = await getSchoolsByUser(state.id);
    setSchools(usd.data);
    onUserSchools(usd.data);
  }

  async function fetchOwnerSchoolData() {
    const osd = await getSchoolsByOwner(state.id);
    setSchools(osd.data);
    onOwnerSchools(osd.data);
  }

  React.useEffect(() => {
    
    try {

      if (state.isOwner) {
        if (
          ownerSchools &&
          Array.isArray(ownerSchools) &&
          ownerSchools.length > 0
        ) {
          setSchools(ownerSchools);
        } else {
          fetchOwnerSchoolData();
        }
      } else {
        if (
          userSchools &&
          Array.isArray(userSchools) &&
          userSchools.length > 0
        ) {
          setSchools(userSchools);
        } else {
          fetchUserSchoolData();
        }
      }

      if (schools && Array.isArray(schools) && schools.length > 0) {
        setHasSchool(true);
      }
    } catch (error) {}
  }, [schools, schId, isCreateSchool]);

  const items = [
    {
      label: "Logout",
      icon: "pi pi-power-off",
      command: () => {
        push(constants.routes.logout);
        toastW.current.show(
          utils.toastCallback({
            severity: "success",
            summary: "Logout",
            detail: "Logout successfully",
          })
        );
      },
    },
  ];

  const selectSchool = async (item) => {
    let toastData;

    try {
      
      const roles = await getRole(item.id);

      console.log(roles.data);

      onSelectSchool({
        schoolId: item.id,
        schoolName: item.name,
        schoolDescription: item.description,
        roles: roles.data,
      });

      push(constants.routes.dashboard);

    } catch (err) {
      if (err.responseCodeDescription) {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "User Error",
          detail: err.responseCodeDescription,
        });
      } else {
        toastData = utils.toastCallback({
          severity: "error",
          summary: "Network Error",
          detail: constants.networkErrorMessage,
        });
      }
    }

    toastW.current.show(toastData);
  };

  const deleteSchoolCommand = async (id) => {
    await deleteSchool(id);
  };

  const acceptFunction = (id, title) => {
    deleteSchoolCommand(id);
    toastW.current.show(
      utils.toastCallback({
        severity: "info",
        summary: "Confirmed",
        detail: `You successfully deleted ${title}`,
        life: 3000,
      })
    );
    setSchId(null);
    resetSchool();
  };

  const rejectFunction = (id, title) => {
    toastW.current.show(
      utils.toastWCallback({
        severity: "warn",
        summary: "Rejected",
        detail: `You cancelled deleting ${title}`,
        life: 3000,
      })
    );
  };

  const confirmDelete = (id, name) => {
    setSchool({ id: id, title: name });
    confirmDialog({
      message: `Do you want to delete this ${name}?`,
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptFunction(id, name),
      reject: () => rejectFunction(id, name),
    });
  };

  const addSchool = () => {
    setSchId(null);
    setIsCreateSchool(true);
  };

  const editSchool = (id) => {
    setSchId(id);
    setIsCreateSchool(true);
  };

  const itemTemplate = (item) => {
    return (
      <div className="flex flex-wrap p-2 align-items-center gap-3">
        <img
          className="w-4rem shadow-2 flex-shrink-0 border-round"
          src={SchoolHat}
          alt={item.name}
        />
        <div
          onClick={async () => await selectSchool(item)}
          className="flex-1 flex flex-column gap-2 xl:mr-8"
        >
          <span className="font-bold">{item.name}</span>
          <div className="flex align-items-center gap-2">
            <i className="pi pi-tag text-sm"></i>
            <span>{item.motto}</span>
          </div>
        </div>
        <span
          onClick={() => editSchool(item.id)}
          className="font-bold text-900"
        >
          <i className="pi pi-pencil text-blue-500"></i>
        </span>
        <span
          onClick={() => confirmDelete(item.id, item.name)}
          className="font-bold text-900"
        >
          <i className="pi pi-trash text-red-500"></i>
        </span>
      </div>
    );
  };

  const noSchool = state.isOwner ? (
    <div className="surface-0 text-center mt-7">
      <div className="grid">
        <div className="col-12 md:col-12 mb-4 px-5">
          <span
            className="p-3 shadow-2 mb-3 inline-block"
            style={{ borderRadius: "10px" }}
          >
            <img src={SchoolHat} alt="school-hat" height={50} />
          </span>
          <div className="text-900 text-xl mb-3 font-medium">
            Create your School
          </div>
          <span className="text-700 line-height-3">
            Duis aute irure dolor in reprehenderit in voluptate velit esse
            cillum dolore eu fugiat nulla pariatur.
          </span>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );

  const schoolDisplay = (
    <div>
      <Divider align="center"></Divider>
      <div className="card xl:flex xl:justify-content-center">
        <OrderList
          value={schools}
          onChange={(e) => setSchools(e.value)}
          itemTemplate={itemTemplate}
          header="School(s)"
          filter
          filterBy="name"
        ></OrderList>
      </div>
    </div>
  );

  return (
    <div className="surface-0 text-700 text-center" style={{ height: "93vh" }}>
      <div className="text-900 font-bold text-5xl mb-3 mt-5">
        WELCOME TO THE HOUSE OF BOOKS
      </div>

      <div className="text-700 text-2xl mb-5">
        Together We Learn, Together We Grow.
      </div>

      {state.isOwner ? (
        <SplitButton
          label="Add Now"
          onClick={() => addSchool()}
          model={items}
          icon="pi pi-plus"
          className="font-bold px-5 py-3 p-button-rounded white-space-nowrap"
        />
      ) : (
        <></>
      )}

      {hasSchool ? schoolDisplay : noSchool}

      <AddEditSchool
        onEdit={handleOnEidt}
        schoolId={schId}
        isCreateSchool={isCreateSchool}
        setIsCreateSchool={setIsCreateSchool}
      />

      <Toast ref={toastW} />
    </div>
  );
};

export default Welcome;
